import { LogoMark } from "@/components/Logo";
import { scrollToId } from "@/lib/api";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-gold/10 bg-black">
    <div className="mx-auto max-w-7xl px-6 py-20 sm:px-12 lg:px-20">
      <p className="font-serif text-[13vw] leading-none font-bold tracking-tight text-slate-100/5 select-none sm:text-8xl lg:text-9xl" aria-hidden="true">
        SKY SUITE
      </p>
      <div className="mt-12 grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark size={30} />
            <span className="font-display text-sm tracking-[0.3em] text-slate-100">SKY SUITE RENTALS</span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-500">
            Luxury vehicle rental and downtown penthouse stays. From the runway to
            the 45th floor, one name handles it all.
          </p>
        </div>
        <div>
          <p className="eyebrow">Explore</p>
          <div className="mt-5 flex flex-col gap-3">
            {[["condo", "The Penthouse"], ["fleet", "The Fleet"], ["package", "Touchdown Royal"], ["booking", "Reserve"]].map(([id, label]) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)}
                className="w-fit text-left text-sm text-zinc-400 transition-colors hover:text-gold">
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="eyebrow">Concierge Desk</p>
          <div className="mt-5 space-y-3 text-sm text-zinc-400">
            <p data-testid="footer-phone">1-800-717-7052</p>
            <p data-testid="footer-email">crenterprisellc@crenterprise.network</p>
            <p>Downtown Atlanta, Georgia</p>
          </div>
        </div>
      </div>
      <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-gold/10 pt-8 font-mono text-[10px] tracking-[0.25em] text-zinc-600 uppercase">
        <span>33.7537° N · 84.3863° W</span>
        <span>©2026 SKY SUITE RENTALS. ALL RIGHTS RESERVED.</span>
      </div>
    </div>
  </footer>
);
